import AbsComponent from "../../components/AbsComponent";

export default class ListFavorite extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);

        let watchD = this.watch(this.store.getState, 'favorite', this.isEqual);
        this.store.subscribe( watchD( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));

        this.addEvents();
    }

    setting(){
    }

    render(_data = {}){
        $(this.el + ' .ico-favorite').toggleClass('is-active', _data==='true');
    }
    
    addEvents(){
        $(this.el + ' button[data-name="btn-favorite"]').on('click', e => {
            let fav = (this.store.getState().favorite === 'true')? 'false': 'true';

            this.router.goMultiParam({
                favorite: fav,
                fromitemid: '',
                page: 1
            });
        });
    }


} // end of class